import Config from '@/config'
var padDate = function(va) {
	va = va < 10 ? '0' + va : va;
	return va
};
//格式化时间
let formatDate = function(val) {
	if (val && val != '0001-01-01T00:00:00') {
		var value = new Date(val);
		var year = value.getFullYear();
		var month = padDate(value.getMonth() + 1);
		var day = padDate(value.getDate());
		var hour = padDate(value.getHours());
		var minutes = padDate(value.getMinutes());
		var seconds = padDate(value.getSeconds());
		return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
	} else {
		return '-';
	}
};
let formatShortDateTime = function(val) {
	if (val && val != '0001-01-01T00:00:00') {
		var value = new Date(val);
		var year = value.getFullYear();
		var month = padDate(value.getMonth() + 1);
		var day = padDate(value.getDate());
		var hour = padDate(value.getHours());
		var minutes = padDate(value.getMinutes());
		return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes;
	} else {
		return '-';
	}
};
let formatTime = function(val) {
	if (val && val != '0001-01-01T00:00:00') {
		var value = new Date(val);
		var hour = padDate(value.getHours());
		var minutes = padDate(value.getMinutes());
		return hour + ':' + minutes;
	} else {
		return '-';
	}
};
let formatSecondsTime = function(val) {
	if (val && val != '0001-01-01T00:00:00') {
		var value = new Date(val);
		var hour = padDate(value.getHours());
		var minutes = padDate(value.getMinutes());
		var seconds = padDate(value.getSeconds());
		return hour + ':' + minutes + ':' + seconds;
	} else {
		return '-';
	}
};
let toShortDate = function(val) {
	if (val && val != '0001-01-01T00:00:00') {
		var value = new Date(val);
		var year = value.getFullYear();
		var month = padDate(value.getMonth() + 1);
		var day = padDate(value.getDate());
		var hour = padDate(value.getHours());
		var minutes = padDate(value.getMinutes());
		var seconds = padDate(value.getSeconds());
		return year + '-' + month + '-' + day;
	} else {
		return '-';
	}
};
let toWeekDate = function(val) {
	var value = new Date(val);
	const daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
	const dayOfWeek = daysOfWeek[value.getDay()];
	return dayOfWeek;
};

let getDateDifference = function(date) {
	const currentDate = new Date();
	currentDate.setHours(0, 0, 0, 0);
	const targetDate = new Date(date);
	targetDate.setHours(0, 0, 0, 0);

	const timeDiff = targetDate - currentDate;
	const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

	if (dayDiff === 0) {
		return '今天';
	} else if (dayDiff === 1) {
		return '明天';
	} else if (dayDiff === -1) {
		return '昨天';
	} else if (dayDiff > 0) {
		return `再过 ${dayDiff} 天`;
	} else {
		return `${Math.abs(dayDiff)} 天前`;
	}
}

//初始化图片
let initImage = function(val) {
	if (!val) {
		return '';
	} else if (val.indexOf('http') >= 0 || val.indexOf('data:image') >= 0) {
		return val;
	} else {
		return Config.imgUrlHost + val;
	}
}
//转换为图片显示
let toImage = function(val) {
	if (val) {
		return Config.imgUrlHost + val;
	} else {
		return Config.notImage;
	}
}
//转换为头像显示
let toFaceImage = function(val) {
	if (!val) {
		return Config.faceImage;
	} else if (val.indexOf('http') >= 0) {
		return val;
	} else {
		return Config.imgUrlHost + val;
	}
}

let ellipsis = function(value, limit) {
	if (!value) return ''
	if (value.length > limit) {
		return value.slice(0, limit) + '...'
	}
	return value
}

export {
	formatDate,
	toShortDate,
	formatShortDateTime,
	formatTime,
	toImage,
	initImage,
	toFaceImage,
	ellipsis,
	toWeekDate,
	getDateDifference,
	formatSecondsTime
}